"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameNameOptions = void 0;
exports.getDefaultSettings = getDefaultSettings;
const BetLimit_1 = require("../bets/BetLimit");
const ForcedBet_1 = require("../bets/ForcedBet");
const BuyLastCardUpSetting_1 = require("../enums/BuyLastCardUpSetting");
const interfaces_1 = require("../interfaces");
const FiveCardDrawOptions_1 = require("./FiveCardDrawOptions");
const FiveCardStudOptions_1 = require("./FiveCardStudOptions");
const FollowTheQueenOptions_1 = require("./FollowTheQueenOptions");
const GutsOptions_1 = require("./GutsOptions");
const HighChicagoOptions_1 = require("./HighChicagoOptions");
const HollywoodSquaresOptions_1 = require("./HollywoodSquaresOptions");
const IronCrossOptions_1 = require("./IronCrossOptions");
const LowChicagoOptions_1 = require("./LowChicagoOptions");
const OmahaOptions_1 = require("./OmahaOptions");
const PassTheTrashOptions_1 = require("./PassTheTrashOptions");
const RollYourOwnOptions_1 = require("./RollYourOwnOptions");
const SevenCardStudOptions_1 = require("./SevenCardStudOptions");
const SevenTwentySevenOptions_1 = require("./SevenTwentySevenOptions");
const TexasDropemOptions_1 = require("./TexasDropemOptions");
const TexasHoldemOptions_1 = require("./TexasHoldemOptions");
const TheSlutOptions_1 = require("./TheSlutOptions");
exports.gameNameOptions = {
    [interfaces_1.Game.FiveCardDraw]: FiveCardDrawOptions_1.FiveCardDrawOptions,
    [interfaces_1.Game.FiveCardStud]: FiveCardStudOptions_1.FiveCardStudOptions,
    [interfaces_1.Game.SevenCardStud]: SevenCardStudOptions_1.SevenCardStudOptions,
    [interfaces_1.Game.TexasHoldem]: TexasHoldemOptions_1.TexasHoldemOptions,
    [interfaces_1.Game.FollowTheQueen]: FollowTheQueenOptions_1.FollowTheQueenOptions,
    [interfaces_1.Game.LowChicago]: LowChicagoOptions_1.LowChicagoOptions,
    [interfaces_1.Game.HighChicago]: HighChicagoOptions_1.HighChicagoOptions,
    [interfaces_1.Game.RollYourOwn]: RollYourOwnOptions_1.RollYourOwnOptions,
    [interfaces_1.Game.IronCross]: IronCrossOptions_1.IronCrossOptions,
    [interfaces_1.Game.HollywoodSquares]: HollywoodSquaresOptions_1.HollywoodSquaresOptions,
    [interfaces_1.Game.TheSlut]: TheSlutOptions_1.TheSlutOptions,
    [interfaces_1.Game.Omaha]: OmahaOptions_1.OmahaOptions,
    [interfaces_1.Game.SevenTwentySeven]: SevenTwentySevenOptions_1.SevenTwentySevenOptions,
    [interfaces_1.Game.Texas]: TexasDropemOptions_1.TexasDropemOptions,
    [interfaces_1.Game.PassTheTrash]: PassTheTrashOptions_1.PassTheTrashOptions,
    [interfaces_1.Game.Guts]: GutsOptions_1.GutsOptions,
};
function getDefaultSettings(game) {
    if (!game || !exports.gameNameOptions[game]) {
        return null;
    }
    const gameOption = exports.gameNameOptions[game];
    const defaultVersion = gameOption.versions.find((option) => !!option.default);
    if (!defaultVersion) {
        console.log(`Undefined default version for game: ${game}`);
        throw new Error(`Undefined default version for game: ${game}`);
    }
    // Find the default options for each section
    const defaultWinner = gameOption.winners.find((option) => !!option.default);
    const defaultOption = gameOption.options.find((option) => !!option.default);
    const defaultWildcard = gameOption.wildcards.find((option) => !!option.default);
    // defaults to Spread Limit
    let betting = {
        limitType: BetLimit_1.BetLimit.SPREAD_LIMIT,
        forcedBetType: ForcedBet_1.ForcedBet.ANTES,
        allowAllIn: false,
    };
    if (defaultVersion.betLimit === BetLimit_1.BetLimit.NO_LIMIT) {
        betting = {
            limitType: BetLimit_1.BetLimit.NO_LIMIT,
            forcedBetType: ForcedBet_1.ForcedBet.BLINDS,
            allowAllIn: true,
        };
    }
    return Object.assign({ highLowSetting: defaultWinner === null || defaultWinner === void 0 ? void 0 : defaultWinner.value, rollYourOwnSetting: defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.value, buyLastCardUpSetting: (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.description) === "Buy Last Card Up"
            ? BuyLastCardUpSetting_1.BuyLastCardUpSetting.ENABLED
            : BuyLastCardUpSetting_1.BuyLastCardUpSetting.DISABLED, wildcardSetting: defaultWildcard === null || defaultWildcard === void 0 ? void 0 : defaultWildcard.value, gameFlavor: defaultVersion.flavor }, betting);
}
//# sourceMappingURL=gameNameOptions.js.map